<svg
  width="18"
  height="18"
  class="shrink-0"
  viewBox="0 0 16 16">
  <use class="fill-current" [attr.xlink:href]="icon()"></use>
</svg>
